import { render, staticRenderFns } from "./addEvent.vue?vue&type=template&id=20969424&"
import script from "./addEvent.vue?vue&type=script&lang=js&"
export * from "./addEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20969424')) {
      api.createRecord('20969424', component.options)
    } else {
      api.reload('20969424', component.options)
    }
    module.hot.accept("./addEvent.vue?vue&type=template&id=20969424&", function () {
      api.rerender('20969424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/eventmanagement/eventList/component/addEvent.vue"
export default component.exports